/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Paper, Grid,
} from '@material-ui/core';
import cloneDeep from 'lodash/cloneDeep';

import CreateAndEditWrapper from '../share/CreateAndEditWrapper';
import { resourceFormStyle, commonResourceStyle } from '../../css/style';
import {
  couponActionTypes,
  resourceFields,
  validationErrorMessages,
} from '../../data/Constants';
import FormTextField from '../share/FormTextField';
import FormSwitchField from '../share/FormRadioField';
import FormDropDownField from '../share/FormDropDownField';
import { createRequestData } from '../../utils/Functions';
import * as FieldValidation from '../crud/CreateAndEditResource/FieldValidation';

const styles = resourceFormStyle();
const commonStyles = commonResourceStyle();
class CreateAndEditCoupon extends Component {
  constructor(props) {
    super(props);
    const { match, type, coupons } = this.props;
    const { resource, resourceId } = match.params;
    const fields = resourceFields[resource];
    const couponDetail = {};
    fields.forEach((field) => {
      const { key } = field;
      const detail = {
        ...field,
        value: '',
        errorMessage: '',
        isValid: true,
      };
      couponDetail[key] = detail;
    });

    if (type === 'edit') {
      const itemToEdit = coupons.find(coupon => coupon.id === parseInt(resourceId));
      Object.values(couponDetail).forEach((detail) => {
        const { key } = detail;
        detail.value = !!itemToEdit ? itemToEdit[key] : '';
      });
    }

    this.state = {
      couponDetail,
    };
  }

  areFieldsValid = () => {
    const { couponDetail } = this.state;
    let areAllValid = true;
    const copyOfCouponDetail = cloneDeep(couponDetail);
    const { isRequiredError } = validationErrorMessages.field;
    Object.values(copyOfCouponDetail).forEach((detail) => {
      const { isRequired, value } = detail;
      if (isRequired && !value) {
        detail.isValid = false;
        detail.errorMessage = isRequiredError;
        areAllValid = false;
      } else if (!detail.isValid) {
        areAllValid = false;
      }
    });
    if (!areAllValid) {
      this.setState({
        couponDetail: copyOfCouponDetail,
      });
    }
    return areAllValid;
  }

  onClickApplyChanges = async () => {
    const {
      actions, history, apiToken, match, type,
    } = this.props;
    const {
      resource, resourceId
    } = match.params;
    const { couponDetail } = this.state;

    const requestData = createRequestData(couponDetail);
    const resourcePath = type === 'edit' ? [resource, resourceId] : [resource];
    if (!this.areFieldsValid()) {
      return;
    }
    const { updateCoupon, addCoupon } = actions;
    const action = type === 'edit' ? updateCoupon : addCoupon;
    action(apiToken, requestData, ...resourcePath).then(async (res) => {
      if (res.error) {
        return;
      }
      history.push(`/${resource}`);
    });
  }

  validateDiscountAmount = ({ newValue }) => {
    const {
      couponDetail,
    } = this.state;
    const {
      actionValue,
    } = couponDetail;
    const { isRequiredError, invalidDecimalError } = validationErrorMessages.field;
    const numberValidations = FieldValidation.validateNumberTypes(newValue, actionValue);
    let errorMessage = '';
    if (numberValidations.invalidDecimal) {
      errorMessage = `${actionValue.title} ${invalidDecimalError}`;
    } else if (!newValue) {
      errorMessage = `${isRequiredError}`;
    }
    return errorMessage;
  }

  handleValueChange = ({ newValue, key, errorMsg }) => {
    const { couponDetail } = this.state;
    const updatedDetail = cloneDeep(couponDetail);
    const updatedField = updatedDetail[key];
    updatedField.value = newValue;
    updatedField.errorMessage = errorMsg;
    updatedField.isValid = !updatedField.errorMessage;
    this.setState({
      couponDetail: updatedDetail,
    });
  }

  render() {
    const {
      couponDetail,
    } = this.state;
    const {
      code, title, description, exclusive, autoApply, actionValue, actionType
    } = couponDetail;
    return (
      <CreateAndEditWrapper
        {...this.props}
        onClickApplyChanges={this.onClickApplyChanges}
      >
        <Paper style={commonStyles.paperNoHeight}>
          <form noValidate autoComplete="off" style={styles.formContainer}>
            <Grid
              container
              spacing={24}
              style={{ ...styles.gridContainer, width: '100%' }}
            >
              <FormTextField
                field={code}
                handleValueChange={this.handleValueChange}
              />
              <FormTextField
                field={title}
                handleValueChange={this.handleValueChange}
              />
              <FormTextField
                field={description}
                handleValueChange={this.handleValueChange}
                isMultipleRow
              />
              <FormDropDownField
                {...this.props}
                field={actionType}
                dropdownOptions={couponActionTypes}
                handleValueChange={this.handleValueChange}
              />
              <FormTextField
                field={actionValue}
                handleValueChange={this.handleValueChange}
                customValidator={this.validateDiscountAmount}
              />
              <FormSwitchField
                field={exclusive}
                handleValueChange={this.handleValueChange}
              />
              <FormSwitchField
                field={autoApply}
                handleValueChange={this.handleValueChange}
              />
            </Grid>
          </form>
        </Paper>
      </CreateAndEditWrapper>
    );
  }
}

export default connect(
  state => ({
    coupons: state.get('coupons').toJS().couponList,
  }),
)(CreateAndEditCoupon);
